module.exports = __webpack_public_path__ + "img/logo.49582822.png";